// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"76":"common","775":"stimulsoft"}[chunkId] || chunkId) + "." + {"15":"066e788f","76":"6f64fecf","297":"34e52c3c","341":"66f03ea7","613":"849cd676","624":"7356ed44","629":"5740dbdc","673":"e346c7aa","762":"35985956","775":"08c0e2da","796":"7bb06d73","904":"bf0ef555"}[chunkId] + ".chunk.js";
};